import { Address, erc4626Abi, zeroAddress } from "viem"

import { MEZO_CHAIN } from "#/shared/constants"

import { useEstimateTransactionGasWithApprove } from "../contract"

import useVaultUnderlyingToken from "./useVaultUnderlyingToken"

export default function useEstimateDepositIntoVaultGas(
  vault: Address,
  receiver: Address,
  amount?: bigint,
) {
  const { data: underlyingToken } = useVaultUnderlyingToken(vault)

  return useEstimateTransactionGasWithApprove(
    {
      tokenContractAddress: underlyingToken ?? zeroAddress,
      amountToSpent: amount ?? 0n,
      spender: vault,
    },
    {
      abi: erc4626Abi,
      functionName: "deposit",
      args: [amount ?? 0n, receiver],
      address: vault,
    },
    {
      chainId: MEZO_CHAIN.id,
      query: {
        enabled: !!amount && !!underlyingToken,
        // TODO: We need to hardcode the gas because we can't estimate the gas
        // without `erc20.approve` transaction. In case the user doesn't have
        // enough approved amount (then `useEstimateGas` will fail and default
        // value will be used). In some cases users may have already approved
        // amount or infinite approval, so this hook will dynamically estimate
        // the gas.
        initialData: 52328n,
      },
    },
  )
}
